export const DISCOUNT_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_VALUE: 'FIXED_VALUE',
  PRODUCT_REQUIRED: 'PRODUCT_REQUIRED',
};
